<template>
  <table class="table is-striped is-hoverable is-fullwidth is-bordered">
    <tbody>
      <tr
        v-for="(value, key) in localStore"
        :key="key"
      >
        <td class="tw-font-semibold tw-pr-4">
          {{ key }}
        </td>
        <td>
          <input
            v-if="editable"
            v-model="localStore[key]"
            class="input is-small"
          >
          <template v-else>{{ value }}</template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>

export default {
  name: 'EditableKeyValue',
  props: {
    store: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localStore: [],
    };
  },
  watch: {
    store: {
      immediate: true,
      handler(newStore) {
        this.localStore = JSON.parse(JSON.stringify(newStore));
      },
    },
    editable(newValue, oldValue) {
      // When switching from edit mode to view mode, emit the update
      if (oldValue && !newValue) {
        this.$emit('update', this.localStore);
      }
    },
  },
};
</script>
